import { IMerchMutation, IMerchMutationForm } from 'services/merch/types';

export const merchFormToQuery = (
  merchForm: IMerchMutationForm
): IMerchMutation => {
  const { id, contracts, gallery, ...merch } = {
    ...merchForm,
    contractRequests: merchForm.contracts,
    EAN: merchForm.EAN.toString(),
  };

  return merch;
};
